export default __webpack_public_path__ + "static/media/wade.40237ba2.mp4";